export default {
  name: 'Opening Hours',
  edit: {
    form: 'open-hours',
    label: 'Edit Opening Hours',
    handler: value => value,
  },
};
